module.exports = __webpack_public_path__ + "img/lv11.69b47ab7.png";